/*
 * Spinlab hata sınırı. Hata kayda düşer (`[spinlab]` önekiyle konsola);
 * görünüm başka bir şemaya düşmez: kabuk düzeyinde tek başına bir hata
 * ekranı, sayfa düzeyinde kabuğun içinde temanın kendi boş durumu çizilir.
 */
import React from 'react';
import { tk } from './i18n';

const BACKGROUND = '#0b0f1a';

const ShellFailure = () => (
  <main style={{ position: 'fixed', inset: 0, display: 'grid', placeItems: 'center', background: BACKGROUND, color: '#e5e7eb', fontFamily: 'sans-serif', padding: 24, textAlign: 'center' }}>
    <div>
      <h1 style={{ fontSize: 20, marginBottom: 8 }}>{tk('spl.boundary.title')}</h1>
      <p style={{ fontSize: 14, opacity: 0.7, marginBottom: 20 }}>{tk('spl.boundary.text')}</p>
      <button type="button" onClick={() => window.location.reload()} style={{ padding: '10px 20px', borderRadius: 8, background: '#7c3aed', color: '#ffffff', fontWeight: 600 }}>
        {tk('spl.boundary.retry')}
      </button>
    </div>
  </main>
);

export class SpinlabBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Hata kayda düşer; görünüm başka şemaya karışmaz.
    // eslint-disable-next-line no-console
    console.error(`[spinlab] ${this.props.scope || 'shell'} render hatası`, error, info?.componentStack);
  }

  componentDidUpdate(previous) {
    if (this.state.error && previous.resetKey !== this.props.resetKey) {
      this.setState({ error: null });
    }
  }

  render() {
    if (this.state.error) return this.props.fallback ?? <ShellFailure />;
    return this.props.children;
  }
}

